import PropTypes from 'prop-types';

export const CompanyCodePropTypes = PropTypes.shape({
  periodName: PropTypes.string,
  companyCode: PropTypes.string.isRequired,
  ccDescription: PropTypes.string,
  enabledFlag: PropTypes.string.isRequired,
  legalEntity: PropTypes.string,
  businessUnit: PropTypes.string,
  chartName: PropTypes.string,
  connName: PropTypes.string,
  associatedLeCountryCode: PropTypes.string,
  associatedLeGoldId: PropTypes.string,
  associatedLeUsTaxType: PropTypes.string,
  associatedLeLocalTaxType: PropTypes.string,
  overrideUsTaxType: PropTypes.string,
  overrideLocalTaxType: PropTypes.string,
  functionalCurrency: PropTypes.string,
  overrideTaxCurrency: PropTypes.string,
  homeOfficeCompanyCode: PropTypes.string,
  homeOfficeCountryCode: PropTypes.string,
  branch: PropTypes.string,
  recordFTC: PropTypes.string.isRequired,
  usShareholderFlag: PropTypes.string,
  businessCode: PropTypes.string,
  businessDescription: PropTypes.string,
  lineOfBusiness: PropTypes.string,
  ledgerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ledgerShortName: PropTypes.string,
  source: PropTypes.string.isRequired,
  subledgerFlag: PropTypes.string,
  statCalc: PropTypes.string,
  statCurrency: PropTypes.string,
  costCenter: PropTypes.string,
  project: PropTypes.string,
  reference: PropTypes.string,
  productLine: PropTypes.string,
  profitCenter: PropTypes.string,
  ledgerIdIn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ledgerIdOut: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  funcCurrencyOverride: PropTypes.string,
  leOverride: PropTypes.string,
  ccOverride: PropTypes.string,
  jeFlag: PropTypes.string,
});

export const CompanyCodesPropTypes = PropTypes.arrayOf(CompanyCodePropTypes.isRequired).isRequired;

export const CompanyCodeDetailsPropTypes = PropTypes.shape({
  companyCode: PropTypes.string,
  legalEntity: PropTypes.string,
  businessUnit: PropTypes.string,
  associatedLeGoldId: PropTypes.string,
  associatedLeCountryCode: PropTypes.string,
  associatedLeUsTaxType: PropTypes.string,
  associatedLeLocalTaxType: PropTypes.string,
  connName: PropTypes.string,
  chartName: PropTypes.string,
  functionalCurrency: PropTypes.string,
  statCurrency: PropTypes.string,
  overrideTaxCurrency: PropTypes.string,
  usShareholderFlag: PropTypes.string,
  associatedLeBranch: PropTypes.string,
  homeOfficeCompanyCode: PropTypes.string,
  homeOfficeCountryCode: PropTypes.string,
  recordHomeOfficeTaxes: PropTypes.string,
  recordFTC: PropTypes.string,
  ledgerId: PropTypes.string,
  subledgerFlag: PropTypes.string,
  statCalc: PropTypes.string,
});
